import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation, validations } from "../../common/validation.common";
import { ResellerCategoryEnum } from "../../data/enums";

export namespace ResellerValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            phone: baseVals.phone(),
            email: v.optional(baseVals.email()),
            username: baseVals.username(),
            password: baseVals.password(),
            address: baseVals.string(),
            location: baseVals.coordinate(),
            productIds: v.pipe(v.array(v.string())),
            category: v.optional(v.picklist(ResellerCategoryEnum.values)),
            area: v.optional(baseVals.string()),
            identityNumber: v.optional(baseVals.identityNumber()),
            notes: v.optional(baseVals.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            phone: v.exactOptional(baseVals.phone()),
            email: v.exactOptional(baseVals.email()),
            username: v.exactOptional(baseVals.username()),
            password: v.exactOptional(baseVals.password()),
            address: v.exactOptional(baseVals.string()),
            location: v.exactOptional(baseVals.coordinate()),
            productIds: v.exactOptional(v.array(v.string())),
            category: v.exactOptional(v.picklist(ResellerCategoryEnum.values)),
            area: v.exactOptional(baseVals.string()),
            identityNumber: v.exactOptional(baseVals.identityNumber()),
            notes: v.exactOptional(baseVals.string()),
        }),
    );

    export const Remove = defineValidation(
        v.object({
            phone: validations.deletable,
        }),
    );

    export const UpdateProduct = defineValidation(
        v.object({
            productId: v.string(),
        }),
    );

    export const Coords = defineValidation(
        v.object({
            lat: v.number(),
            lng: v.number(),
            radius: v.number(),
        }),
    );
}
